import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { collection, query, orderBy, limit, getDocs } from 'firebase/firestore';
import PostCard from '../components/PostCard';
import HeroSection from '../components/HeroSection';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export default function Home() {
  const { initializing } = useAuth();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (initializing) return;

    const fetchPosts = async () => {
      const q = query(collection(db, 'posts'), orderBy('createdAt', 'desc'), limit(20));
      const snapshot = await getDocs(q);
      setPosts(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
      setLoading(false);
    };
    fetchPosts();
  }, [initializing]);

  return (
    <>
      <HeroSection />

      <div className="space-y-6">
        {loading ? (
          <div className="flex flex-col items-center justify-center h-64">
            <Loader2 className="animate-spin text-cyan-400" size={48} />
            <p className="text-gray-400 mt-4">Loading Community Feed...</p>
          </div>
        ) : posts.length === 0 ? (
          <div className="text-center py-16 glass-card rounded-xl">
            <h3 className="text-xl font-semibold text-white">The feed is empty</h3>
            <p className="text-gray-500 mt-2 mb-6">Be the first to create a post!</p>
            <Link to="/submit" className="inline-block px-6 py-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white font-semibold rounded-lg hover:from-cyan-400 hover:to-blue-400 transition-all shadow-lg shadow-cyan-500/20">
              Submit a Report
            </Link>
          </div>
        ) : (
          posts.map(post => <PostCard key={post.id} post={post} />)
        )}
      </div>
    </>
  );
}

